import { FUNCTION_URLS } from "../config/functionUrls";

const CHAT_HISTORY_URL = FUNCTION_URLS.vexaChatHistory;
const FEEDBACK_URL = FUNCTION_URLS.vexaFeedback;

export async function loadChatHistory(dni) {
  try {
    const res = await fetch(`${CHAT_HISTORY_URL}?dni=${encodeURIComponent(dni)}`);
    if (!res.ok) return [];
    const data = await res.json();
    // Map backend fields to frontend format
    return (data.messages || []).map(m => ({
      ...m,
      text: m.answer || m.question || m.text || "",
    }));
  } catch (err) {
    console.warn("[chat] Error loading history:", err);
    return [];
  }
}

export async function saveMessages(dni, newMessages) {
  // Messages are already saved by the backend when Axis processes them.
  // This function is called for user messages (not sent by backend).
  // We don't need to save them from frontend since Axis already does it.
  return true;
}

export async function saveFeedback(dni, messageIndex, feedback) {
  try {
    const res = await fetch(FEEDBACK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ dni, messageIndex, feedback }),
    });
    return res.ok;
  } catch (err) {
    console.warn("[chat] Error saving feedback:", err);
    return false;
  }
}
